import React, { useState } from 'react';
import './Hero.css';
import ContactModal from './ContactModal';

const Hero = () => {
  const [showContactModal, setShowContactModal] = useState(false);
  return (
    <section id="home" className="hero">
      <div className="hero-video-bg">
        <video
          src={process.env.PUBLIC_URL + '/intro.mp4'}
          className="hero-bg-video"
          autoPlay
          loop
          muted
          playsInline
          controls={false}
          poster=""
        />
      </div>
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Automation. Intelligence. Precision.
            </h1>
            <p className="hero-subtitle">
              Idle Robotics delivers advanced mapping, geolocation, and autonomy solutions for defense, industrial, and critical infrastructure applications.
            </p>
            <div className="hero-actions">
              <a href="#solutions" className="btn btn-primary">
                Explore Products
              </a>
              <button className="btn btn-outline" onClick={() => setShowContactModal(true)}>
                Request Demo
              </button>
            </div>
            {/* <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-number">500+</span>
                <span className="stat-label">Deployments</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">15+</span>
                <span className="stat-label">Industries</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">99.9%</span>
                <span className="stat-label">Uptime</span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {/* <div className="hero-background">
        <div className="bg-pattern"></div>
      </div> */}
      {showContactModal && <ContactModal onClose={() => setShowContactModal(false)} />}
    </section>
  );
};

export default Hero;